import { render, staticRenderFns } from "./KindergartenWishlistNotification.vue?vue&type=template&id=8d929be6&scoped=true"
import script from "./KindergartenWishlistNotification.vue?vue&type=script&lang=js"
export * from "./KindergartenWishlistNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d929be6",
  null
  
)

export default component.exports